// ============================================================
// THEME: NASHVILLE SUPERSPEEDWAY
// ------------------------------------------------------------
// Cracker Barrel 400 — whiskey gold + Broadway neon-pink on
// smoky midnight-denim. Same racing vocabulary as Talladega.
// ============================================================

const nashville = {
  id: 'nashville',
  name: 'Nashville Superspeedway',
  short: 'NASHVILLE',

  colors: {
    pink:   '#FFB627',   // WHISKEY GOLD
    teal:   '#FF2D78',   // BROADWAY NEON PINK
    yellow: '#F5E9D0',
    dark:   '#0E1117',
    panel:  '#171C26',
    text:   '#F5E9D0',
  },

  raw: {
    accentPrimary:   '#FFB627',
    accentSecondary: '#FF2D78',
    glow:            '#FF2D78',
    pinGlow:         '#FFB627',
    squadPin:        '#FF2D78',
    iconText:        '#FFB627',
    iconRing:        '#FF2D78',
  },

  branding: {
    logo:    '/bender-racing-logo.png',
    logoAlt: 'Bender Racing',
    title:   'NASHVILLE TRACKER',
    titleAccent: 'TRACKER',
    tagline: 'Powered by Bender Extender',
    footer:  'v2.0 • Bender Racing',
  },

  labels: {
    primaryAction:   'REFUEL',
    secondaryAction: 'PIT STOP',
    endSession:      'CHECKERED FLAG',
    startSession:    'GREEN FLAG',
    squadLabel:      'PIT CREW',
    squadCountFmt:   '{n} ACTIVE',
    rankingsLabel:   'RANK',
    liveBadge:       'LIVE',
    statsHeader:     'Race Stats',
    durationLabel:   'DURATION',
    drinksLabel:     'FUEL',
    stepsLabel:      'STEPS',
  },

  map: {
    tileUrl:         'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    tileSubdomains:  '',
    tileAttribution: 'Tiles &copy; Esri',
    maxZoom:         19,
    containerBg:     '#0E1117',
  },

  venueTypes: {
    default:  { emoji: '🏁', bg: 'bg-zinc-800/80',    border: 'border-zinc-500' },
    drink:    { emoji: '🍺', bg: 'bg-brand-teal/50',  border: 'border-brand-teal' },
    vendor:   { emoji: '🌭', bg: 'bg-brand-pink/50',  border: 'border-brand-pink' },
    bathroom: { emoji: '🚻', bg: 'bg-blue-500/50',    border: 'border-blue-500' },
    supply:   { emoji: '💊', bg: 'bg-emerald-500/50', border: 'border-emerald-500' },
    party:    { emoji: '🎉', bg: 'bg-purple-500/50',  border: 'border-purple-500' },
    concert:  { emoji: '🎸', bg: 'bg-orange-500/50',  border: 'border-orange-500' },
  },

  themeColor: '#0E1117',
  font: {
    display: "'Inter', sans-serif",
    mono:    "'JetBrains Mono', monospace",
  },
};

export default nashville;
